export * from './debug'

// MCP tools are only available in Tauri environment
// In web environment, export an empty array
export const mcp = async () => []
